import { render, staticRenderFns } from "./HouseTabReminders.vue?vue&type=template&id=1f285310&"
import script from "./HouseTabReminders.vue?vue&type=script&lang=js&"
export * from "./HouseTabReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports